/**
 * okbye.ca \u2014 Free Gift + Upsell Cart Drawer (v6)
 * + Free shipping bar style Rhode
 * + T-shirt gratuit style Kylie (en haut du drawer)
 */

(function () {

  console.log("%c[okbye] side cart COORDINATEUR v31 charg\u00e9", "color:#fff;background:#D94F3D;padding:2px 6px;border-radius:4px");

  // \u2500\u2500\u2500 CONFIG \u2014 MODIFIER ICI \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  // Cadeau inclus automatiquement dans chaque commande (style Kylie)
  var INCLUDED_GIFT = {
    variantId: 46695759610055,
    handle: "sent-bon-gratuit",
    displayLabel: "Sent-bon",
  };
  var GIFTS = [INCLUDED_GIFT];

  var UPSELLS = [
    { variantId: null, handle: "awaye-lache-ton-cell-pis-etudie-menthe-poivree-jasmin-fleur-de-citronnier", displayLabel: "Jasmin & Menthe Poivr\u00e9e", badge: "Bougie du mois" },
    { variantId: null, handle: "la-pince-signature",                    displayLabel: "La Pince Signature" },
    { variantId: null, handle: "le-porte-cles-espresso-martini",        displayLabel: "Le Porte-Cl\u00e9s Espresso Martini" },
    { variantId: null, handle: "pina-colada-chocolats-favoris-x-ok-bye", displayLabel: "Pi\u00f1a Colada" },
    { variantId: null, handle: "sans-titre-12juil-_22-24-36",           displayLabel: "La mitaine de four" },
    { variantId: null, handle: "briquet-electrique-rechargeable",       displayLabel: "Le Briquet \u00c9lectrique Rechargeable" },
  ];

  // T-shirt gratuit (style Kylie)
  var TSHIRT = {
    variantId: 46666125508807,
    handle: "docapp-free-gift-t-shirt-gratuit",
    displayLabel: "T-Shirt Ok Bye GRATUIT",
    threshold: 9900,   // 99$ en centimes
    comparePrice: "44,95 $",
    description: "D\u00e9pense encore %REMAINING% pour d\u00e9bloquer ton t-shirt gratuit!",
    unlockedMsg: "Ton t-shirt gratuit est d\u00e9bloqu\u00e9 \u2014 ajoute-le \u00e0 ta commande!",
  };

  // Seuils
  var FREE_SHIPPING_THRESHOLD = 12500; // 125$

  // Texte d\u00e9tails cadeau
  var DETAILS_TEXT = "Re\u00e7ois un cadeau gratuit avec chaque commande, pendant les stocks disponibles. Choisis entre un sent-bon ou une cuill\u00e8re \u00e0 cr\u00e8me glac\u00e9e. Le cadeau est ajout\u00e9 automatiquement \u00e0 ta commande \u2014 aucun code requis. Non \u00e9changeable, non remboursable.";

  // \u2500\u2500\u2500 STATE \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  var GIFT_VARIANT_IDS = GIFTS.map(function(g) { return g.variantId; });
  var ALL_FREE_IDS = GIFT_VARIANT_IDS.slice();
  var selectedGiftIndex = 0;
  var currentUpsellIndex = 0;
  var giftImages = {};
  var upsellImages = {};
  var upsellPrices = {};
  var upsellOnSale = {};
  var upsellCompare = {};
  var upsellAddVariant = {};
  var currentCartVariantIds = [];
  var cartIsEmpty = false;
  var tshirtImage = "";
  var imagesLoaded = false;
  var clickListenerAttached = false;
  var detailsOpen = false;

  // \u2500\u2500\u2500 IMAGES \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  async function loadImages() {
    if (imagesLoaded) return;
    var all = GIFTS.concat(UPSELLS);
    await Promise.all(all.map(async function(p) {
      try {
        var res = await fetch("/products/" + p.handle + ".js");
        var data = await res.json();
        var img = data.featured_image || (data.images && data.images[0] && data.images[0].src) || "";
        if (p.variantId === TSHIRT.variantId) {
          tshirtImage = img;
        } else if (GIFT_VARIANT_IDS.indexOf(p.variantId) !== -1) {
          giftImages[p.handle] = img;
        } else {
          upsellImages[p.handle] = img;
          var variants = data.variants || [];
          var avail = variants.filter(function(x){ return x.available; });
          avail.sort(function(a, b){ return a.price - b.price; });
          var chosen = avail[0] || null;
          if (chosen) {
            upsellAddVariant[p.handle] = chosen.id;
            if (typeof chosen.price === "number") upsellPrices[p.handle] = chosen.price;
            var cmp = chosen.compare_at_price;
            if (cmp && cmp > chosen.price) { upsellCompare[p.handle] = cmp; upsellOnSale[p.handle] = true; }
            else { upsellOnSale[p.handle] = false; }
          }
        }
      } catch(e) {}
    }));
    imagesLoaded = true;
  }

  // \u2500\u2500\u2500 CART API \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + " $";
  }

  async function fetchCart() {
    var res = await fetch("/cart.js");
    return res.json();
  }

  async function addToCart(variantId, properties) {
    var res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties || {} }),
    });
    var data = await res.json();
    if (!res.ok) throw new Error(data.description || "Erreur");
    return data;
  }

  async function removeFromCart(variantIds) {
    var cart = await fetchCart();
    var updates = {};
    cart.items.forEach(function(item) {
      if (variantIds.indexOf(item.variant_id) !== -1) updates[item.variant_id] = 0;
    });
    if (!Object.keys(updates).length) return;
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates }),
    });
  }

  // Anti-exploit: garde au MAX 1 cadeau (parmi les options) + MAX 1 t-shirt, peu importe comment le client a trich\u00e9
  async function enforceGiftLimits(cart) {
    var updates = {};
    var changed = false;
    var keptOptionGift = false;
    cart.items.forEach(function(i) {
      if (GIFT_VARIANT_IDS.indexOf(i.variant_id) !== -1) {
        if (!keptOptionGift) {
          keptOptionGift = true;
          if (i.quantity > 1) { updates[i.variant_id] = 1; changed = true; }
        } else {
          updates[i.variant_id] = 0; changed = true;
        }
      } else if (i.variant_id === TSHIRT.variantId && i.quantity > 1) {
        updates[i.variant_id] = 1; changed = true;
      }
    });
    if (!changed) return false;
    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates }),
      });
      return true;
    } catch(e) { return false; }
  }

  async function refreshNativeCart() {
    return new Promise(function(resolve) {
      fetch("/?sections=mini-cart")
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var html = data["mini-cart"];
          if (html) {
            var el = document.getElementById("mini-cart");
            if (el) {
              el.innerHTML = new DOMParser()
                .parseFromString(html, "text/html")
                .querySelector(".shopify-section").innerHTML;
            }
          }
          resolve();
        })
        .catch(function() { resolve(); });
    });
  }

  // \u2500\u2500\u2500 SYNC \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  var isSyncing = false;
  var syncTimer = null;
  function debouncedSync(delay) { clearTimeout(syncTimer); syncTimer = setTimeout(syncAndRender, delay || 400); }

  var pendingSync = false;
  async function syncAndRender() {
    if (isSyncing) {
      // Don't drop - schedule a retry after current sync finishes
      pendingSync = true;
      return;
    }
    isSyncing = true;
    pendingSync = false;
    try {
    // Fetch images in background - don't block rendering
    if (!imagesLoaded) loadImages().then(function() {
      // Re-render once images are ready if drawer is open
      var w = document.getElementById("okbye-gift-widget");
      if (w) debouncedSync(50);
    });
    var cart = await fetchCart();
    // Garde-fou anti-exploit avant tout rendu
    if (await enforceGiftLimits(cart)) {
      await refreshNativeCart();
      cart = await fetchCart();
    }
    currentCartVariantIds = cart.items.map(function(i){ return i.variant_id; });

    var hasGift = cart.items.some(function(i) { return GIFT_VARIANT_IDS.indexOf(i.variant_id) !== -1; });
    var hasTshirt = cart.items.some(function(i) { return i.variant_id === TSHIRT.variantId; });
    var hasReal = cart.items.some(function(i) { return ALL_FREE_IDS.indexOf(i.variant_id) === -1; });
    var realTotal = 0;
    cart.items.forEach(function(i) {
      if (ALL_FREE_IDS.indexOf(i.variant_id) === -1) realTotal += i.final_line_price;
    });

    cartIsEmpty = !hasReal;
    // Panier sans vrai produit \u2192 retire les freebies (anti-checkout 0$) mais MONTRE les incitatifs
    if (!hasReal) {
      if (hasGift || hasTshirt) {
        await removeFromCart(ALL_FREE_IDS);
        await refreshNativeCart();
        cart = await fetchCart();
        currentCartVariantIds = cart.items.map(function(i){ return i.variant_id; });
      }
      renderAll(cart, 0, false, false);
      document.dispatchEvent(new CustomEvent("okbye:cart-ready", { detail: { cart: cart } }));
      if (window.okbyeShippingBarRender) window.okbyeShippingBarRender(cart);
    } else {
      // Cadeau inclus: ajoute le sent-bon automatiquement s'il n'est pas d\u00e9j\u00e0 dans le panier
      if (!hasGift) {
        try {
          await addToCart(INCLUDED_GIFT.variantId, { _gift: "true" });
          await refreshNativeCart();
          cart = await fetchCart();
          currentCartVariantIds = cart.items.map(function(i){ return i.variant_id; });
          hasGift = true;
        } catch(e) {}
      }
      renderAll(cart, realTotal, hasGift, false);
      document.dispatchEvent(new CustomEvent("okbye:cart-ready", { detail: { cart: cart } }));
      if (window.okbyeShippingBarRender) window.okbyeShippingBarRender(cart);
    }
    } catch(e) { console.log('[okbye]', e); } finally { isSyncing = false; if (pendingSync) { pendingSync = false; debouncedSync(100); } }
  }

  // \u2500\u2500\u2500 WIDGET ROOT \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  function removeWidget() {
    ["okbye-shipping-bar", "okbye-tshirt-bloc", "okbye-gift-widget", "okbye-included-gift"].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.remove();
    });
    clickListenerAttached = false;
  }

  function renderAll(cart, realTotal, hasGift, hasTshirt) {
    var drawer = document.querySelector("#mini-cart, .mini-cart, [data-mini-cart]");
    if (!drawer) return;

    renderShippingBar(drawer, cart, realTotal);
    renderIncludedGift(drawer);
    renderGiftWidget(drawer, hasGift);
    lockGiftQuantities(drawer);
  }

  // Verrouille la quantit\u00e9 des cadeaux gratuits \u00e0 1 (cache le s\u00e9lecteur).
  // Diff\u00e9rents cadeaux peuvent coexister, mais jamais 2x le m\u00eame.
  function lockGiftQuantities(drawer) {
    if (!drawer) return;
    ALL_FREE_IDS.forEach(function(vid) {
      var lis = drawer.querySelectorAll('li[data-variant-id="' + vid + '"]');
      Array.prototype.forEach.call(lis, function(li) {
        li.classList.add("okbye-gift-line");
        var input = li.querySelector(".quantity__input");
        if (input) {
          input.setAttribute("readonly", "readonly");
          input.setAttribute("tabindex", "-1");
        }
        var links = li.querySelectorAll("a.product-title, a.product-image");
        Array.prototype.forEach.call(links, function(a) {
          a.style.pointerEvents = "none";
          a.setAttribute("tabindex", "-1");
          a.removeAttribute("href");
        });
      });
    });
  }

  function findFooter() {
    var selectors = [".mini-cart__footer", ".cart-drawer__footer", ".mini-cart__buttons", "[data-mini-cart-footer]"];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    var btn = document.querySelector('[name="checkout"], .mini-cart__checkout, .cart__checkout-button');
    return btn ? (btn.closest("div[class*='footer'], footer, form") || btn.parentElement) : null;
  }

  function findItemsTop() {
    // Top du contenu du drawer (avant les items)
    var selectors = [".mini-cart__items", ".cart-drawer__items", "[data-mini-cart-items]", ".mini-cart__scroll"];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  // \u2500\u2500\u2500 1. FREE SHIPPING BAR style Rhode \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  // Cadeau inclus (sent-bon) \u2014 bandeau info, ajout\u00e9 automatiquement, pas de bouton
  function renderIncludedGift(drawer) {
    var el = document.getElementById("okbye-included-gift");
    if (!el) {
      el = document.createElement("div");
      el.id = "okbye-included-gift";
      var bar = document.getElementById("okbye-shipping-bar");
      if (bar) { bar.insertAdjacentElement("afterend", el); }
      else { drawer.prepend(el); }
    }
    var img = giftImages[INCLUDED_GIFT.handle] || "";
    var imgHTML = img
      ? '<img src="' + img + '" alt="' + INCLUDED_GIFT.displayLabel + '" class="okbye-inc-img" />'
      : '<div class="okbye-inc-img okbye-inc-img--placeholder"></div>';
    el.innerHTML =
      '<div class="okbye-inc-wrap">' +
        imgHTML +
        '<div class="okbye-inc-info">' +
          '<p class="okbye-inc-tag">Cadeau inclus \u2014 ajout\u00e9 \u00e0 chaque commande</p>' +
          '<p class="okbye-inc-name">' + INCLUDED_GIFT.displayLabel + '</p>' +
        '</div>' +
        '<span class="okbye-inc-free">GRATUIT</span>' +
      '</div>';
  }

  function renderShippingBar(drawer, cart, realTotal) {
    var bar = document.getElementById("okbye-shipping-bar");
    if (!bar) {
      bar = document.createElement("div");
      bar.id = "okbye-shipping-bar";
      // Injecte tout en haut du drawer, avant les items
      var top = findItemsTop();
      if (top) {
        top.parentElement.insertBefore(bar, top);
      } else {
        drawer.prepend(bar);
      }
    }

    var itemCount = 0;
    cart.items.forEach(function(i) {
      if (ALL_FREE_IDS.indexOf(i.variant_id) === -1) itemCount += i.quantity;
    });

    var remaining = FREE_SHIPPING_THRESHOLD - realTotal;
    var progressPct = Math.min((realTotal / FREE_SHIPPING_THRESHOLD) * 100, 100);

    var msg = "";
    var fillColor = "#1A1A1A";
    if (remaining <= 0) {
      msg = '<span class="okbye-bar-done">Livraison gratuite d\u00e9bloqu\u00e9e</span>';
      fillColor = "#A9BCA3";
    } else {
      var remainingFormatted = (remaining / 100).toFixed(2).replace(".", ",");
      msg = "Ajoute <strong>" + remainingFormatted + " $</strong> pour la livraison gratuite";
    }

    bar.innerHTML =
      '<div class="okbye-bar-inner">' +
        '<div class="okbye-bar-top">' +
          '<span class="okbye-bar-count">' + itemCount + ' article' + (itemCount > 1 ? 's' : '') + '</span>' +
          '<span class="okbye-bar-msg">' + msg + '</span>' +
        '</div>' +
        '<div class="okbye-bar-track" style="height:7px !important;width:100% !important;background:#E6E2DA !important;border-radius:99px;overflow:hidden;display:block !important">' +
          '<div class="okbye-bar-fill" style="width:' + progressPct + '% !important;height:7px !important;min-width:6px;background:' + fillColor + ' !important;border-radius:99px;display:block !important"></div>' +
        '</div>' +
      '</div>';
  }

  // \u2500\u2500\u2500 2. T-SHIRT BLOC style Kylie \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  function renderTshirtBloc(drawer, realTotal, hasTshirt) {
    var bloc = document.getElementById("okbye-tshirt-bloc");
    if (!bloc) {
      bloc = document.createElement("div");
      bloc.id = "okbye-tshirt-bloc";
      // Place juste apr\u00e8s la shipping bar
      var bar = document.getElementById("okbye-shipping-bar");
      if (bar && bar.nextSibling) {
        bar.parentElement.insertBefore(bloc, bar.nextSibling);
      } else {
        var top = findItemsTop();
        if (top) top.parentElement.insertBefore(bloc, top);
      }
      bloc.addEventListener("click", handleTshirtClick);
    }

    var unlocked = realTotal >= TSHIRT.threshold;
    var remaining = ((TSHIRT.threshold - realTotal) / 100).toFixed(2).replace(".", ",");
    var imgHTML = tshirtImage
      ? '<img src="' + tshirtImage + '" alt="' + TSHIRT.displayLabel + '" class="okbye-ts-img" />'
      : '<div class="okbye-ts-img okbye-ts-img--placeholder"></div>';

    if (hasTshirt) {
      // T-shirt already in cart - hide this block entirely
      bloc.style.display = 'none';
    } else if (unlocked) {
      // D\u00e9bloqu\u00e9 mais pas encore ajout\u00e9
      bloc.innerHTML =
        '<div class="okbye-ts-inner okbye-ts-inner--unlocked">' +
          imgHTML +
          '<div class="okbye-ts-info">' +
            '<p class="okbye-ts-label">\ud83c\udf89 ' + TSHIRT.unlockedMsg + '</p>' +
            '<p class="okbye-ts-sub">' + TSHIRT.displayLabel + '</p>' +
            '<p class="okbye-ts-price"><s>' + TSHIRT.comparePrice + '</s> <strong>GRATUIT</strong></p>' +
          '</div>' +
          '<button id="okbye-ts-btn" class="okbye-ts-btn" type="button">Ajouter</button>' +
        '</div>';
    } else {
      // Pas encore d\u00e9bloqu\u00e9
      var desc = TSHIRT.description.replace("%REMAINING%", "<strong>" + remaining + " $</strong>");
      bloc.innerHTML =
        '<div class="okbye-ts-inner">' +
          imgHTML +
          '<div class="okbye-ts-info">' +
            '<p class="okbye-ts-label">' + desc + '</p>' +
            '<p class="okbye-ts-sub">' + TSHIRT.displayLabel + '</p>' +
            '<p class="okbye-ts-price"><s>' + TSHIRT.comparePrice + '</s> GRATUIT</p>' +
          '</div>' +
        '</div>';
    }
  }

  async function handleTshirtClick(e) {
    var btn = e.target.closest("#okbye-ts-btn");
    if (!btn || btn.disabled) return;
    e.preventDefault(); e.stopPropagation();
    btn.textContent = "...";
    btn.disabled = true;
    try {
      await addToCart(TSHIRT.variantId, { _gift: "true" });
      await refreshNativeCart();
      clickListenerAttached = false;
      await syncAndRender();
    } catch(err) {
      btn.textContent = "Erreur";
      btn.disabled = false;
    }
  }

  // \u2500\u2500\u2500 3. GIFT WIDGET (cadeau choix) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  function renderGiftWidget(drawer, giftAdded, _attempt) {
    var footer = findFooter();
    if (!footer) {
      // Footer not ready yet (mobile loads slower) - retry up to 5x
      var attempt = (_attempt || 0) + 1;
      if (attempt <= 5) {
        setTimeout(function() { renderGiftWidget(drawer, giftAdded, attempt); }, 200 * attempt);
      }
      return;
    }

    var widget = document.getElementById("okbye-gift-widget");
    if (!widget) {
      widget = document.createElement("div");
      widget.id = "okbye-gift-widget";
      footer.parentElement.insertBefore(widget, footer);
    }

    renderUpsell(widget);

    if (!clickListenerAttached) {
      widget.addEventListener("click", handleGiftClick);
      clickListenerAttached = true;
    }
  }

  async function handleGiftClick(e) {
    var choiceBtn = e.target.closest(".okbye-gift-choice");
    if (choiceBtn) {
      e.preventDefault(); e.stopPropagation();
      selectedGiftIndex = parseInt(choiceBtn.dataset.gift);
      var gw = document.getElementById("okbye-gift-widget");
      if (gw) renderGiftSelector(gw);
      return;
    }

    var giftBtn = e.target.closest("#okbye-gift-btn");
    if (giftBtn && !giftBtn.disabled) {
      e.preventDefault(); e.stopPropagation();
      giftBtn.textContent = "...";
      giftBtn.disabled = true;
      try {
        await addToCart(GIFTS[selectedGiftIndex].variantId, { _gift: "true" });
        currentUpsellIndex = 0;
        await refreshNativeCart();
        clickListenerAttached = false;
        isSyncing = false; // Force reset before re-render
        await syncAndRender();
      } catch(err) {
        giftBtn.textContent = "Erreur";
        giftBtn.disabled = false;
      }
      return;
    }

    var upsellBtn = e.target.closest("#okbye-upsell-btn");
    if (upsellBtn && !upsellBtn.disabled) {
      e.preventDefault(); e.stopPropagation();
      var id = parseInt(upsellBtn.dataset.id);
      upsellBtn.textContent = "...";
      upsellBtn.disabled = true;
      try {
        await addToCart(id);
        await refreshNativeCart();
        clickListenerAttached = false;
        debouncedSync();
      } catch(err) {
        upsellBtn.textContent = "Erreur";
        upsellBtn.disabled = false;
      }
      return;
    }

    var detailsBtn = e.target.closest("#okbye-details-toggle");
    if (detailsBtn) {
      e.preventDefault(); e.stopPropagation();
      detailsOpen = !detailsOpen;
      var panel = document.getElementById("okbye-details-panel");
      var label = document.getElementById("okbye-details-label");
      if (panel) panel.style.display = detailsOpen ? "block" : "none";
      if (label) label.textContent = detailsOpen ? "fermer les d\u00e9tails" : "plus de d\u00e9tails";
      return;
    }

    var closeBtn = e.target.closest("#okbye-details-close");
    if (closeBtn) {
      e.preventDefault(); e.stopPropagation();
      detailsOpen = false;
      var panel = document.getElementById("okbye-details-panel");
      var label = document.getElementById("okbye-details-label");
      if (panel) panel.style.display = "none";
      if (label) label.textContent = "plus de d\u00e9tails";
      return;
    }

    var prevBtn = e.target.closest("#okbye-upsell-prev");
    if (prevBtn) { e.preventDefault(); e.stopPropagation(); currentUpsellIndex = currentUpsellIndex - 1; clickListenerAttached = false; renderGiftWidget(document.querySelector("#mini-cart"), true); return; }

    var nextBtn = e.target.closest("#okbye-upsell-next");
    if (nextBtn) { e.preventDefault(); e.stopPropagation(); currentUpsellIndex = currentUpsellIndex + 1; clickListenerAttached = false; renderGiftWidget(document.querySelector("#mini-cart"), true); return; }
  }

  function renderGiftSelector(container) {
    var gift = GIFTS[selectedGiftIndex];
    var imgUrl = giftImages[gift.handle] || "";
    var choicesHTML = GIFTS.map(function(g, i) {
      return '<button type="button" class="okbye-gift-choice' + (i === selectedGiftIndex ? ' okbye-gift-choice--on' : '') + '" data-gift="' + i + '">' + g.displayLabel + '</button>';
    }).join("");
    var imgHTML = imgUrl
      ? '<img id="okbye-gift-img" src="' + imgUrl + '" alt="' + gift.displayLabel + '" class="okbye-gift-img" />'
      : '<div class="okbye-gift-img okbye-gift-img--placeholder"></div>';

    container.innerHTML =
      '<div class="okbye-widget">' +
        '<div class="okbye-gift-label"><span class="okbye-gift-tag">CHOISIS TON CADEAU GRATUIT &mdash; ON TE G&Acirc;TE &lt;3</span></div>' +
        '<div class="okbye-gift-body">' +
          '<div class="okbye-gift-img-wrap">' + imgHTML + '</div>' +
          '<div class="okbye-gift-info">' +
            '<div class="okbye-gift-choices">' + choicesHTML + '</div>' +
          '</div>' +
          (cartIsEmpty
            ? '<button id="okbye-gift-btn" class="okbye-gift-btn" type="button" disabled>Avec ta commande</button>'
            : '<button id="okbye-gift-btn" class="okbye-gift-btn" type="button">Ajouter</button>') +
        '</div>' +
        '<div class="okbye-details-bar">' +
          '<button id="okbye-details-toggle" class="okbye-details-toggle" type="button">' +
            '<span id="okbye-details-label">plus de d\u00e9tails</span>' +
            '<svg viewBox="0 0 10 6" width="10" height="6" style="margin-left:4px;opacity:.5"><path d="M0 0l5 6 5-6z" fill="currentColor"/></svg>' +
          '</button>' +
        '</div>' +
        '<div id="okbye-details-panel" class="okbye-details-panel" style="display:none;">' +
          '<button id="okbye-details-close" class="okbye-details-close" type="button">&times;</button>' +
          '<div class="okbye-details-inner">' +
            (imgUrl ? '<img src="' + imgUrl + '" alt="' + gift.displayLabel + '" class="okbye-details-img" />' : '') +
            '<div class="okbye-details-content">' +
              '<p class="okbye-details-title">Cadeau gratuit avec ta commande</p>' +
              '<p class="okbye-details-text">' + DETAILS_TEXT + '</p>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

  }

  function renderUpsell(container) {
    // Rhode-style: ne sugg\u00e8re que des produits PAS d\u00e9j\u00e0 dans le panier, cycle sans fin
    var available = UPSELLS.filter(function(u) {
      var addId = upsellAddVariant[u.handle] || u.variantId;
      if (addId == null) return false;
      return currentCartVariantIds.indexOf(u.variantId) === -1 && currentCartVariantIds.indexOf(addId) === -1;
    });
    if (available.length === 0) {
      container.innerHTML = '';
      container.style.display = 'none';
      return;
    }
    container.style.display = '';
    // Normalise l'index (wrap des deux bords, jamais de cul-de-sac)
    currentUpsellIndex = ((currentUpsellIndex % available.length) + available.length) % available.length;
    var u = available[currentUpsellIndex];
    var img = upsellImages[u.handle] || "";
    var imgHTML = img
      ? '<img src="' + img + '" alt="' + u.displayLabel + '" class="okbye-upsell-img" />'
      : '<div class="okbye-upsell-img okbye-upsell-img--placeholder"></div>';
    var progress = (currentUpsellIndex + 1) + " / " + available.length;

    var priceHTML = '';
    if (upsellOnSale[u.handle] && upsellCompare[u.handle] != null) {
      priceHTML = '<span class="okbye-upsell-price"><s class="okbye-upsell-was">' + formatMoney(upsellCompare[u.handle]) + '</s> <span class="okbye-upsell-now">' + formatMoney(upsellPrices[u.handle]) + '</span></span>';
    } else if (upsellPrices[u.handle] != null) {
      priceHTML = '<span class="okbye-upsell-price">' + formatMoney(upsellPrices[u.handle]) + '</span>';
    }
    var badgeHTML = u.badge ? '<span class="okbye-upsell-badge">' + u.badge + '</span>' : '';

    container.innerHTML =
      '<div class="okbye-widget">' +
        '<div class="okbye-upsell-header">' +
          '<p class="okbye-upsell-title">Compl\u00e8te ton ambiance Ok Bye</p>' +
          '<span class="okbye-upsell-progress">' + progress + '</span>' +
        '</div>' +
        '<div class="okbye-upsell-card">' +
          imgHTML +
          '<span class="okbye-upsell-meta"><span class="okbye-upsell-name">' + u.displayLabel + '</span>' + priceHTML + badgeHTML + '</span>' +
          '<button id="okbye-upsell-btn" class="okbye-upsell-btn" type="button" data-id="' + (upsellAddVariant[u.handle] || u.variantId) + '">Ajouter</button>' +
        '</div>' +
        '<div class="okbye-upsell-nav">' +
          (available.length > 1 ? '<button class="okbye-upsell-skip" id="okbye-upsell-prev" type="button">&#8592; Pr\u00e9c\u00e9dent</button>' : '<span></span>') +
          (available.length > 1 ? '<button class="okbye-upsell-skip" id="okbye-upsell-next" type="button">Suivant &#8594;</button>' : '') +
        '</div>' +
      '</div>';
  }

  // \u2500\u2500\u2500 STYLES \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  // CSS cibl\u00e9 par variant-id pour cacher le stepper des lignes cadeau
  function buildGiftQtyCSS() {
    var sel = ALL_FREE_IDS.map(function(id) { return 'li[data-variant-id="' + id + '"]'; });
    return sel.map(function(s) { return s + ' .quantity__button'; }).join(',') + '{display:none!important}' +
           sel.map(function(s) { return s + ' quantity-input.quantity'; }).join(',') + '{border:0!important;height:auto;background:transparent}' +
           sel.map(function(s) { return s + ' .quantity__input'; }).join(',') + '{pointer-events:none;border:0;background:transparent;width:1.6em;min-width:0;padding:0;text-align:center;font-weight:500;color:#6B675F}' +
           sel.map(function(s) { return s + ' a.product-title,' + s + ' a.product-image'; }).join(',') + '{pointer-events:none!important;cursor:default!important;text-decoration:none!important;border-bottom:0!important;background-image:none!important;color:#1A1A1A!important}';
  }

  function injectStyles() {
    if (document.getElementById("okbye-gift-styles")) return;
    var style = document.createElement("style");
    style.id = "okbye-gift-styles";
    style.textContent = [
      /* \u2500\u2500 Shipping bar \u2014 Rhode blend-in \u2500\u2500 */
      "#okbye-shipping-bar{padding:16px 18px 12px;border-bottom:1px solid #E9E6DF;background:#FBFAF7}",
      ".okbye-bar-top{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:9px}",
      ".okbye-bar-count{font-size:11px;font-weight:500;color:#8C8881;text-transform:uppercase;letter-spacing:.14em}",
      ".okbye-bar-msg{font-size:12px;color:#5E5B54;text-align:right;line-height:1.4}",
      ".okbye-bar-msg strong{color:#1A1A1A;font-weight:500}",
      ".okbye-bar-done{color:#5E7A5C;letter-spacing:.02em}",
      ".okbye-bar-track{height:7px;background:#E6E2DA;border-radius:99px;overflow:hidden}",
      ".okbye-bar-fill{height:100%;min-width:7px;background:#1A1A1A;border-radius:99px;transition:width .4s ease}",
      ".okbye-bar-track--done .okbye-bar-fill{background:#A9BCA3}",
      ".okbye-inc-wrap{display:flex;align-items:center;gap:10px;padding:9px 18px;border-bottom:1px solid #E9E6DF}",
      ".okbye-inc-img{width:40px;height:40px;object-fit:cover;border-radius:7px;flex-shrink:0;border:1px solid #E9E6DF}",
      ".okbye-inc-img--placeholder{width:40px;height:40px;border-radius:7px;background:#EDEAE3;flex-shrink:0}",
      ".okbye-inc-info{flex:1;min-width:0}",
      ".okbye-inc-tag{font-size:11px;font-weight:500;text-transform:uppercase;letter-spacing:.12em;color:#8C8881;margin:0 0 2px}",
      ".okbye-inc-name{font-size:16px;font-weight:500;color:#1A1A1A;margin:0;line-height:1.3}",
      ".okbye-inc-free{font-size:11px;font-weight:500;letter-spacing:.06em;color:#5E7A5C;flex-shrink:0}",

      /* \u2500\u2500 T-shirt bloc style Kylie \u2500\u2500 */
      "#okbye-tshirt-bloc{padding:12px 16px;border-bottom:1px solid #EEE;background:#FFF8F5}",
      ".okbye-ts-inner{display:flex;align-items:center;gap:10px}",
      ".okbye-ts-inner--unlocked{background:#FFF0ED;border-radius:10px;padding:10px;margin:-2px}",
      ".okbye-ts-inner--added{background:#F0FFF4;border-radius:10px;padding:10px;margin:-2px}",
      ".okbye-ts-img{width:56px;height:56px;object-fit:cover;border-radius:8px;flex-shrink:0;border:1px solid #F2D5C8}",
      ".okbye-ts-img--placeholder{width:56px;height:56px;border-radius:8px;background:#F5EDE8;flex-shrink:0}",
      ".okbye-ts-info{flex:1;min-width:0}",
      ".okbye-ts-label{font-size:11px;color:#555;margin:0 0 2px;line-height:1.4}",
      ".okbye-ts-label strong{color:#D94F3D}",
      ".okbye-ts-sub{font-size:12px;font-weight:700;color:#1A1A1A;margin:0 0 2px;line-height:1.3}",
      ".okbye-ts-price{font-size:11px;color:#888;margin:0} .okbye-ts-price strong{color:#3A8C55;font-weight:800}",
      ".okbye-ts-btn{flex-shrink:0;padding:8px 12px;background:#D94F3D;color:#fff;border:none;border-radius:7px;font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.05em;cursor:pointer;font-family:inherit;white-space:nowrap;pointer-events:all}",
      ".okbye-ts-btn:hover{background:#b83e2e}",
      ".okbye-ts-btn:disabled{opacity:.5;cursor:not-allowed}",

      /* \u2500\u2500 Gift widget \u2014 Rhode blend-in \u2500\u2500 */
      "#okbye-gift-widget{padding:2px 12px 0;font-family:inherit;position:relative;z-index:1}",
      ".okbye-widget{border:1px solid #E9E6DF;border-radius:12px;overflow:hidden;background:#F6F4EF}",
      ".okbye-gift-label{background:transparent;padding:7px 12px 0;text-align:left}",
      ".okbye-gift-tag{font-size:11px;font-weight:500;color:#6B675F;letter-spacing:.14em;text-transform:uppercase;line-height:1.4}",
      ".okbye-gift-body{display:flex;align-items:center;gap:10px;padding:6px 12px 8px}",
      ".okbye-gift-img{width:40px;height:40px;object-fit:cover;border-radius:7px;border:1px solid #E9E6DF;display:block}",
      ".okbye-gift-img--placeholder{width:46px;height:46px;border-radius:7px;background:#EDEAE3}",
      ".okbye-gift-info{flex:1;min-width:0}",
      ".okbye-gift-name{font-size:14px;font-weight:500;color:#1A1A1A;margin:0 0 2px;line-height:1.3}",
      ".okbye-gift-price{font-size:11px;font-weight:500;color:#5E7A5C;letter-spacing:.06em;margin:0 0 5px;text-transform:uppercase}",
      ".okbye-gift-select{width:100%;padding:6px 9px;border:1px solid #E3DFD7;border-radius:7px;font-size:12px;background:#FBFAF7;color:#1A1A1A;cursor:pointer;font-family:inherit;text-overflow:ellipsis;overflow:hidden}",
      ".okbye-gift-select:focus{outline:none;border-color:#1A1A1A}",
      ".okbye-gift-choices{display:flex;flex-wrap:wrap;gap:6px;margin-top:1px}",
      ".okbye-gift-choice{font-size:12px;padding:7px 12px;border:1px solid #E3DFD7;border-radius:20px;background:#FBFAF7;color:#5E5B54;cursor:pointer;font-family:inherit;line-height:1.2;-webkit-tap-highlight-color:transparent}",
      ".okbye-gift-choice--on{border-color:#1A1A1A;background:#1A1A1A;color:#FBFAF7}",
      ".okbye-gift-btn{flex-shrink:0;padding:9px 15px;background:#1A1A1A;color:#FBFAF7;border:none;border-radius:20px;font-size:10.5px;font-weight:500;text-transform:uppercase;letter-spacing:.1em;cursor:pointer;font-family:inherit;white-space:nowrap;pointer-events:all;position:relative;z-index:2}",
      ".okbye-gift-btn:hover{background:#333}",
      ".okbye-gift-btn:disabled{opacity:.45;cursor:not-allowed}",
      ".okbye-details-bar{border-top:1px solid #E9E6DF;padding:6px 12px;background:transparent}",
      ".okbye-details-toggle{background:none;border:none;cursor:pointer;font-size:10.5px;color:#8C8881;font-family:inherit;display:flex;align-items:center;gap:4px;padding:0;text-decoration:underline;text-underline-offset:2px}",
      ".okbye-details-toggle:hover{color:#1A1A1A}",
      ".okbye-details-panel{background:#2B2622;padding:16px 14px;position:relative}",
      ".okbye-details-close{position:absolute;top:10px;right:12px;background:none;border:none;color:#fff;font-size:18px;cursor:pointer;opacity:.7;padding:0}",
      ".okbye-details-close:hover{opacity:1}",
      ".okbye-details-inner{display:flex;gap:12px;align-items:flex-start}",
      ".okbye-details-img{width:70px;height:70px;object-fit:cover;border-radius:8px;border:1px solid rgba(255,255,255,.15);flex-shrink:0}",
      ".okbye-details-content{flex:1}",
      ".okbye-details-title{font-size:11px;font-weight:500;color:#fff;text-transform:uppercase;letter-spacing:.1em;margin:0 0 6px}",
      ".okbye-details-text{font-size:11px;color:rgba(255,255,255,.72);line-height:1.6;margin:0}",
      ".okbye-upsell-header{padding:6px 12px 0;display:flex;align-items:center;justify-content:space-between}",
      ".okbye-upsell-title{font-size:11px;font-weight:500;color:#8C8881;text-transform:uppercase;letter-spacing:.12em;margin:0}",
      ".okbye-upsell-progress{font-size:11px;color:#A8A39B;white-space:nowrap}",
      ".okbye-upsell-card{display:flex;align-items:center;gap:9px;padding:4px 12px}",
      ".okbye-upsell-img{width:34px;height:34px;object-fit:cover;border-radius:7px;flex-shrink:0;border:1px solid #E9E6DF}",
      ".okbye-upsell-img--placeholder{width:34px;height:34px;border-radius:7px;background:#EDEAE3;flex-shrink:0}",
      ".okbye-upsell-meta{display:flex;flex-direction:column;gap:1px;flex:1;min-width:0}",
      ".okbye-upsell-name{font-size:18px;color:#1A1A1A;font-weight:500;line-height:1.3}",
      ".okbye-upsell-price{font-size:12px;color:#8C8881;font-weight:400}",
      ".okbye-upsell-was{color:#D94F3D;text-decoration:line-through;font-weight:400}",
      ".okbye-upsell-now{color:#1A1A1A;font-weight:500;margin-left:2px}",
      ".okbye-upsell-badge{font-size:11px;color:#D94F3D;font-style:italic;margin-top:1px}",
      ".okbye-upsell-btn{flex-shrink:0;padding:7px 13px;background:#1A1A1A;color:#FBFAF7;border:none;border-radius:20px;font-size:10.5px;font-weight:500;text-transform:uppercase;letter-spacing:.1em;cursor:pointer;font-family:inherit;pointer-events:all}",
      ".okbye-upsell-btn:hover{background:#333}",
      ".okbye-upsell-btn:disabled{opacity:.45;cursor:not-allowed}",
      ".okbye-upsell-nav{display:flex;justify-content:space-between;align-items:center;padding:0 12px 5px;margin-top:0}",
      ".okbye-upsell-skip{background:none;border:none;font-size:10.5px;letter-spacing:.04em;color:#8C8881;cursor:pointer;font-family:inherit;padding:0}",
      ".okbye-upsell-skip:hover{color:#1A1A1A}",
      ".okbye-upsell-done{padding:16px;text-align:center;font-size:13px;color:#1A1A1A;font-weight:500}",
      /* \u2500\u2500 Corps du panier natif \u2014 Rhode blend-in \u2500\u2500 */
      ".mini-cart{background:#FBFAF7;color:#1A1A1A}",
      ".mini-cart__header .title.h4{font-size:1.05rem;font-weight:500;letter-spacing:.01em}",
      ".mini-cart .product-title{font-size:1.125rem;font-weight:500;color:#1A1A1A;text-decoration:none}",
      ".mini-cart .product-container .media{border-radius:7px;overflow:hidden}",
      ".mini-cart quantity-input.quantity{border:1px solid #E3DFD7;border-radius:20px;height:28px;display:inline-flex;align-items:center;overflow:hidden;background:transparent}",
      ".mini-cart .quantity__button{width:28px;height:26px;color:#7A766E}",
      ".mini-cart .quantity__input{width:30px;font-size:.8rem;border:0;background:transparent}",
      ".mini-cart .product-quantity .price{font-weight:500;font-size:.875rem}",
      ".mini-cart__footer .subtotal .label.h3{font-size:1rem;font-weight:500;letter-spacing:.06em;text-transform:uppercase;color:#5E5B54}",
      ".mini-cart__footer .subtotal .value.price{font-size:1.25rem;font-weight:500}",
      ".mini-cart__footer .tax-note{color:#8C8881;font-size:.9rem}",
      ".mini-cart__footer .button-container .button[name=checkout]{width:100%;background:#1A1A1A;color:#FBFAF7;border:0;border-radius:24px;min-height:50px;font-size:1.025rem;letter-spacing:.08em;text-transform:uppercase;font-weight:500}",
      /* Cache Remarque + Livraison (Be Yours exact) */
      ".mini-cart__actions{display:none!important}",
      /* Cache Voir le panier (Be Yours exact) */
      ".mini-cart__footer .button-container a.button{display:none!important}",
      /* Items scrollables */
      "#mini-cart{display:flex;flex-direction:column;overflow:hidden}",
      "#mini-cart>form{display:flex;flex-direction:column;flex:1;overflow:hidden;min-height:0}",
      ".mini-cart__inner{display:flex;flex-direction:column;flex:1;min-height:0}",
      ".mini-cart__main{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;min-height:0}",
      ".mini-cart__items{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;min-height:60px}",
      ".mini-cart__footer{flex-shrink:0}",
      /* Make mini-cart items scrollable so footer is always visible */
      "#mini-cart{display:flex;flex-direction:column;max-height:100vh}",
      ".mini-cart__items,.cart-drawer__items{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch}",
      /* Ensure footer stays at bottom */
      ".mini-cart__footer,.cart-drawer__footer{flex-shrink:0}",
    ].join("") + buildGiftQtyCSS();
    document.head.appendChild(style);
  }

  // \u2500\u2500\u2500 OBSERVER \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  function observeCart() {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var target = m.target;
        if (["okbye-shipping-bar","okbye-tshirt-bloc","okbye-gift-widget","okbye-tshirt-banner"].indexOf(target.id) !== -1) continue;
        if (target.closest && target.closest("#okbye-shipping-bar,#okbye-tshirt-bloc,#okbye-gift-widget,#okbye-tshirt-banner")) continue;
        if (target.id === "mini-cart" || (target.closest && target.closest("#mini-cart"))) {
          clickListenerAttached = false;
          debouncedSync();
          return;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.id === "mini-cart" || (node.querySelector && node.querySelector("#mini-cart,.mini-cart__footer"))) {
            clickListenerAttached = false;
            debouncedSync();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // \u2500\u2500\u2500 INIT \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  function init() {
    injectStyles();
    observeCart();
    // Be Yours cart events
    ["cartdrawer:opened", "cart:open", "drawer:open", "miniCart:open"].forEach(function(evt) {
      document.addEventListener(evt, function() {
        clickListenerAttached = false;
        debouncedSync(200);
      });
    });

    // Tshirt events - refresh native cart then re-render
    document.addEventListener("okbye:tshirt-added", function() {
      refreshNativeCart().then(function() {
        clickListenerAttached = false;
        isSyncing = false;
        debouncedSync(150);
      });
    });
    document.addEventListener("okbye:tshirt-removed", function() {
      refreshNativeCart().then(function() {
        clickListenerAttached = false;
        isSyncing = false;
        debouncedSync(150);
      });
    });
    // Signal from okbye-tshirt-banner after it refreshes the native cart
    document.addEventListener("okbye:cart-refreshed", function() {
      isSyncing = false;
      pendingSync = false;
      clickListenerAttached = false;
      debouncedSync(50);
    });
    // Listen on any element that opens the cart (Be Yours uses various selectors)
    document.addEventListener("click", function(e) {
      var cartTrigger = e.target.closest('[data-mini-cart-toggle], [aria-controls="mini-cart"], .js-mini-cart-toggle, .js-drawer-open-cart, [href="#cart-drawer"], .header__icon--cart');
      if (cartTrigger) {
        // Cart icon clicked - sync after drawer animation (~300ms on mobile)
        setTimeout(function() { debouncedSync(100); }, 350);
        setTimeout(function() { debouncedSync(100); }, 700); // second attempt for slow mobile
      }
    }, true); // capture phase to catch before Be Yours
    document.addEventListener("click", function(e) {
      var addBtn = e.target.closest('[name="add"], [data-add-to-cart], .product-form__submit');
      if (addBtn) debouncedSync();
    });
    syncAndRender();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
